import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, isKnownHost } from "shared/config/firebase";
import { RootLayout } from "shared/layout/RootLayout";
import jwtAuthStore from "shared/store/jwtAuthStore";

export const GuestRoute: React.FC = () => {
  const [ready, setReady] = useState(false);
  const navigate = useNavigate();
  // Use the hook pattern to subscribe to store changes
  const { shouldUseJwt, isVerified, jwtToken } = jwtAuthStore();

  useEffect(() => {
    let startUrl = "/assistant";
    // Check if we're on a known host
    const isOnKnownHost = isKnownHost();

    // If on a known host, handle JWT-specific behavior
    if (isOnKnownHost) {
      setReady(true);

      // If there's a JWT token and it's verified, redirect to assistant
      if (shouldUseJwt && isVerified) {
        navigate(startUrl);
        return;
      }

      // If on a known host but no JWT token or not verified, show the JWT required page
      // This will happen when the user is on a valid host but doesn't have a token in the URL
      if (!jwtToken || !isVerified) {
        navigate("/jwt-auth-required");
        return;
      }
    }

    // Fall back to Firebase auth for non-known hosts
    auth.onAuthStateChanged((user) => {
      setReady(true);
      if (user) {
        navigate(startUrl);
      }
    });
  }, [navigate, shouldUseJwt, isVerified, jwtToken]); // Add these dependencies to react to changes

  if (!ready) return null;

  return <RootLayout />;
};
